import { render, staticRenderFns } from "./AddRequesttipoPage.vue?vue&type=template&id=6c34e312"
import script from "./AddRequesttipoPage.vue?vue&type=script&lang=js"
export * from "./AddRequesttipoPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports